import React, { useEffect, useState } from 'react';
import { Box, Tab } from "@mui/material";
import { ROUTE_PATHS } from "src/routes/paths";
import Tabs from "@mui/material/Tabs";
import { useHistory, useLocation} from "react-router-dom";
import { Download } from './Download';
import { QueuedDownload } from './queuedDownload/QueuedDownload';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          style={{padding:0, margin:0}}
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
          {value === index && <Box>{children}</Box>}
      </div>
  );
};
function a11yProps(index: number) {
  return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
  };
}

const routes = [ROUTE_PATHS.all_downloads, ROUTE_PATHS.queued_download];

export const DownloadTabs: React.FC = () =>{
    const history = useHistory();
    const location = useLocation();
    const [tabValue, setTabValue] = useState(0);
  
    useEffect(()=>{
      if(location?.pathname?.includes(ROUTE_PATHS.all_downloads)){
        setTabValue(0)
      }
      else if(location?.pathname?.includes(ROUTE_PATHS.queued_download)){
        setTabValue(1)
      }
    },[location?.pathname])

  return (
    <div style={{padding: '.1%'}}>
      <Tabs 
        scrollButtons={false}
        value={tabValue}
        onChange={(event, newVal)=>{
          setTabValue(newVal); 
          history.push(`${ROUTE_PATHS.download}${routes[newVal]}`)
        }}
        className="subtabs"
      >
        <Tab label="Download" {...a11yProps(0)}/>
        <Tab label="Queued Download"{...a11yProps(1)}/>
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <Download/>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <QueuedDownload/>
      </TabPanel>
    </div>
  )
}